


















































































































































import {Component, Vue} from "vue-property-decorator";
import {
  PullRefresh,
  Swipe,
  SwipeItem,
  Icon,
  Empty,
  List,
  Loading, Toast
} from "vant";
import FundsRecordItem from "@/components/FundsRecordItem.vue";
import {jumpLink, webViewRightButton} from "@/utils/hybirdMethods";
import {getBrowser} from "@/utils/browser";


import Clipboard from "clipboard";

import amountDisplay from '@/mixins/amountDisplay'

@Component({
  components: {
    [PullRefresh.name]: PullRefresh,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Icon.name]: Icon,
    [FundsRecordItem.name]: FundsRecordItem,
    [Empty.name]: Empty,
    [List.name]: List,
    [Loading.name]: Loading
  },
  mixins: [
    amountDisplay
  ]
})
export default class Index extends Vue {
  accountData: any = null;
  hasBindBankCard: any = null;
  fundsRecordList: any = null;
  isFinishRe1 = false;
  accountRequestFail = false;
  isFinishRe3 = false;
  recordRequestFail = false;
  // myLoading: any = null;
  loadText: any = "";
  IMG_NET_ERR = (this as any).IMG_NET_ERR;
  account_no: any = '';
  account_type: any = 1;
  imgArrayObj:any = null
  initial: number = 0
  isLoading: boolean = false

  get iconArr() {
    return [
      {
        imgUrl: "/static/images/funds_in.png"
      },
      {
        imgUrl: "/static/images/funds_out.png"
      },
      {
        imgUrl: "/static/images/funds_swap.png"
      },
      {
        imgUrl: "/static/images/funds_capital.png"
      },
      {
        imgUrl: "/static/images/funds_transfer.png"
      }
    ]
  }

  loading = false;
  finished = false;
  currPage = 1;
  pageSize = 10;
  isApp = getBrowser().isApp;
  exchange = 0;

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  created() {
    this.loadText = this.$t("public.contentText[4]") || "";
    this.init();

    webViewRightButton({"url":{"type":1,"url":"/funds-management"},"isDisplay":"false","title":""})
  }

  init() {
    this.account_no = this.$route.query.account
    this.account_type = this.$route.query.account_type
    this.getAccountList();
    this.getBankCardInfo();
    this.getFundsRecordInfo();
  }

  // 下拉刷新
  onRefresh() {
    this.isLoading = true
    this.finished = false
    this.currPage = 1
    this.fundsRecordList = [];
    this.getAccountList();
    this.getBankCardInfo();
    this.getFundsRecordInfo();
  }

  // 监听轮播图滚动
  onSwiper(index) {
    this.currPage = 1
    this.account_no = this.accountData[index].account_no
    this.account_type = this.accountData[index].account_type
    this.$router.replace({ query: { ...this.$route.query, account: this.account_no, account_type: this.account_type  } })
    this.finished = false
    this.fundsRecordList = []
    this.getFundsRecordInfo()
  }

  // 获取按钮权限
  getAccountList(){
    (this as any).$apis.getAccountLists().then(res =>{
      this.isFinishRe1 = true;
      this.accountRequestFail = false;
      this.accountData = res.accountInfo
      this.imgArrayObj = res.accountAuth
      this.initial = res.accountInfo.findIndex(item => item.account_no === this.$route.query.account)

      this.isLoading = false
    }).catch(() => {
      this.accountRequestFail = true;
    });
  }

  /**
   * 点击复制账号
   * */
  onCopy () {
    const clipboard = new Clipboard('.account_no')
    clipboard.on('success', e => {
      Toast.success(this.$t('funds.copy'))
      // 释放内存
      clipboard.destroy()
    })
    clipboard.on('error', e => {
      // 不支持复制
      Toast.fail(this.$t('funds.copyFail'))
      // 释放内存
      clipboard.destroy()
    })
  }

  /**
   * 返回是否绑定银行卡
   */
  get isBindBankCard() {
    if (this.hasBindBankCard === null) {
      return "";
    } else {
      return this.hasBindBankCard
          ? this.$t("funds.jsText[0]")
          : this.$t("funds.jsText[1]");
    }
  }

  /**
   * 获取账户信息，页面我的银行卡区域渲染
   */
  getBankCardInfo() {
    (this as any).$apis
        .getBankList({}, {customLoading: true})
        .then(res => {
          this.hasBindBankCard = !!(Array.isArray(res) && res.length);
        })
        .catch(err => {
          
        });
  }

  /**
   * 获取资金记录列表
   */
  getFundsRecordInfo() {
    (this as any).$apis
        .getFundsRecord(
            {
              page: this.currPage,
              page_size: this.pageSize,
              account_type: this.account_type,
              account_no: this.account_no
            },
            {customLoading: true}
        )
        .then(res => {
          const [currentPage, data, lastPage] = [
            res.current_page,
            res.data,
            res.last_page
          ];
          this.isFinishRe3 = true;
          this.loading = false;
          if (lastPage <= currentPage) {
            this.finished = true;
          }
          if (this.currPage === 1) {
            this.fundsRecordList = data;
          } else {
            this.fundsRecordList = [...this.fundsRecordList, ...data];
          }
          this.currPage++;
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
          this.isFinishRe3 = true;
          this.recordRequestFail = true;
        });
  }

  /**
   * 格式化账户信息-账户(总)金额
   * @param item {Object} 账户信息
   * @param index {Number} 序列号
   */
  balanceText(item, index) {
    if (index === 0)
      return (
          (item.base_balance && Number(item.base_balance).toFixed(2)) || "--"
      );
    if (index === 1)
      return (item.balance && `${Number(item.balance).toFixed(2)}`) || "--";
  }

  /**
   * 跳转银行卡列表页
   */
  jumpToBankCardList() {
    this.$router.push({path: "/bank-card-list", query: {
        account_no: this.account_no,
        account_type: this.account_type
      }});
  }

  /**
   * 跳转到资金币种详情
   * @param item {Object} item数据
   * @param index {Number} 序号
   */
  jumpToFundsDetails(item, index) {
    const routeParams: any = {
      name: "funds-details"
    };
    routeParams.query = {
      account_type: item.account_type,
      account_no: item.account_no
    };
    this.$router.push(routeParams);
  }

  /**
   * 跳转到 资金转入/转出/划转
   * @param index
   * @param accountItem {Object} 账户数据
   * type: 1: A账户 2：B账户
   */
  jumpToFundsTransfer(index, accountItem) {
    switch (index) {
      case 0:
        this.$router.push({
          name: "transfer-into-index",
          // query: {type: accountItem.account_type}
          query: {account_type: accountItem.account_type, account_no: accountItem.account_no || accountItem.login_id}
        });
        break;
      case 1:
        this.$router.push(
            `/withdraw?account_type=${
                accountItem.account_type
            }&account_no=${accountItem.account_no || accountItem.login_id || ""}`
        );
        break;
      case 2:
        if (this.isApp) {
          jumpLink({
            url: 'exchange',
            futures_login_id: accountItem.account_no,
            x_channel_id: accountItem.account_type
          });
        }
        break;
      case 3:
        this.jumpToFundsDetails(accountItem, 0);
        break;
      default:
        this.$router.push(
            `/transfer?account_type=${
                accountItem.account_type
            }&account_no=${accountItem.account_no || accountItem.login_id || ""}`
        );
        return;
    }
  }

  /**
   * 跳转订单详情
   * @param item {Object} 记录项数据
   */
  jumpToOrderDetail(item) {
    
    this.$router.push({
      name: "funds-order-detail",
      query: {id: item.record_id, orderType: item.funds_change_type, account_type: item.funds_account_type}
    });
  }

  jumpToAppPage() {
    if (this.isApp) {
      jumpLink({
        url:"capital_flow",
        futures_login_id: this.account_no,
        x_channel_id: this.account_type
      });
    }
  }

  /**
   * @Description computed,弱网状态是否显示
   * @date 2023/12/29
   * @param
   * @return {void}
   */
  get cPoorNetworkEnvironmentStatus() {
    return this.$store.state.network.v_poor_network_environment_status
  }
}
